import values from 'lodash/values';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// REFACTOR THIS!!!
import { getCategoricalSummary } from 'store/dataset/summary';

import CategoricalComponent from './Component';
import { getFrequencyDataSetLength, getFrequencyColumnHeaders } from 'store/dataset';

class CategoricalContainer extends React.PureComponent {

  get levelsSummary () {
    const { parameter, summary } = this.props;

    const frequencySummary = values(summary[parameter].levels);
    return frequencySummary;
  }


  get parameterName () {
    const { parameter } = this.props;


    return parameter;
  }

  render () {
    return <CategoricalComponent levelsSummary={this.levelsSummary} parameterName={this.parameterName} />;
  }
}

CategoricalContainer.propTypes = {
  summary: PropTypes.object.isRequired,
  parameter: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  summary: getCategoricalSummary(state),
  dataSetLength: getFrequencyDataSetLength(state),
  contingencyParameter: getFrequencyColumnHeaders(state)
});

export default connect(mapStateToProps)(CategoricalContainer);
